'use client';

import { useMemo } from 'react';
import { getUVEState } from '@dotcms/uve';
import dynamic from 'next/dynamic';

const DynamicGraphql = dynamic(() => import('./components/graphql/GraphqlPlayground'), {
    ssr: false
});
const DynamicRest = dynamic(() => import('./components/rest/RestApiPlayground'), { ssr: false });
const DynamicImage = dynamic(() => import('./components/image-api'), { ssr: false });

const PlaygroundWrapper = ({ children }) => <div className="min-h-[600px]">{children}</div>;

export const Playground = ({ playground }) => {
    const content = useMemo(() => {
        switch (playground) {
            case 'graphql':
                return (
                    <PlaygroundWrapper>
                        <DynamicGraphql />
                    </PlaygroundWrapper>
                );
            case 'image-api':
                return (
                    <PlaygroundWrapper>
                        <DynamicImage />
                    </PlaygroundWrapper>
                );
            case 'rest-api':
                return (
                    <PlaygroundWrapper>
                        <DynamicRest />
                    </PlaygroundWrapper>
                );
            default:
                return !!getUVEState() ? (
                    <PlaygroundWrapper>Playground Missing: {playground}</PlaygroundWrapper>
                ) : null;
        }
    }, [playground]);

    return content;
};
